import { createContext, useContext, useEffect, useState } from "react";

const SettingsContext = createContext({});

// Public site settings served by the PHP backend (/api/settings.php).
// Falls back silently to static defaults when the API is unavailable.
export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    let active = true;
    const base = process.env.REACT_APP_API_BASE || "";
    fetch(`${base}/api/settings.php`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (active && d && typeof d === "object") setSettings(d);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);

// Returns a settings value if non-empty, else the provided fallback.
export const useSetting = (key, fallback = "") => {
  const s = useContext(SettingsContext);
  const v = s?.[key];
  return v !== undefined && v !== null && v !== "" ? v : fallback;
};
